import React from "react";
import PagedNavTable from "./paged-nav-table";

//mock table for testing and viewing the PagedNavTable component
const SamplePagedNavTableUsage = () => {
  const [sortColumn, setSortColumn] = React.useState("Column No.2");
  const [sortDirection, setSortDirection] = React.useState<"asc" | "desc">("asc");
  const [pageSize, setPageSize] = React.useState(5);
  const [pageNumber, setPageNumber] = React.useState(1);
  const pageOptions = [1, 5, 10, 25, 50, 100];

  let mockOrgs = [];

  let mockColumnDetails: any[] = [
    {
      name: "link tooltip",
      isSorted: false,
      isLink: true,
      onLinkSelect: (data: any) => window.alert(data.name),
      getColumnData: (data: any) => data.name,
      alignment: "left",
      getTooltipContent: (data: any) => "breadbrumb/crumb/" + data.name
    },
    {
      name: "Sort info icon tooltip",
      isSorted: true,
      getColumnData: (data: any) => data.name,
      alignment: "right",
      infoIconContent: "tooltip stuff for info icon"
    },
    {
      name: "Column No.0",
      isSorted: false,
      getColumnData: (data: any) => data.name,
      alignment: "right"
    }
  ];

  mockOrgs.push({
    name: "super long orgname to make it overflow for testing but hey it wasn't long enough yet"
  });

  for (let i = 0; i < 300; i++) {
    mockOrgs.push({ name: "org - " + i.toString() });
  }

  const changesort = (col: string) => {
    if (col === sortColumn) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(col);
      setSortDirection("asc");
    }
  };

  return (
    <PagedNavTable
      title="Mock Institutions"
      columnDetails={mockColumnDetails}
      tableData={mockOrgs.slice((pageNumber - 1) * pageSize, pageNumber * pageSize)}
      tableHeight={"calc(100vh - 100px)"}
      includePagination={true}
      totalItemsCount={mockOrgs.length}
      pageSize={pageSize}
      pageSizeOptions={pageOptions}
      pageNumber={pageNumber}
      pageChange={(page: number) => setPageNumber(page)}
      pageSizeChange={(page: number) => {
        setPageSize(page);
      }}
      sortColumn={sortColumn}
      sortDirection={sortDirection}
      sortChange={changesort}
    />
  );
};

export default SamplePagedNavTableUsage;
